import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { AudioPlayer } from './AudioPlayer';
export function Hero() {
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) element.scrollIntoView({
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    // Load Wistia player scripts
    const script1 = document.createElement('script');
    script1.src = 'https://fast.wistia.com/player.js';
    script1.async = true;
    document.body.appendChild(script1);
    const script2 = document.createElement('script');
    script2.src = 'https://fast.wistia.com/embed/zh6z11cau0.js';
    script2.async = true;
    script2.type = 'module';
    document.body.appendChild(script2);
    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);
  return <section className="relative min-h-[90vh] flex items-start justify-center bg-[#FFF8F0] overflow-hidden py-6 px-4" data-id="element-16">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-17">
        <div className="absolute -top-20 -left-20 w-64 h-64 bg-[#52B788]/10 rounded-full blur-3xl" data-id="element-18" />
        <div className="absolute top-1/3 right-0 w-96 h-96 bg-[#F4A261]/10 rounded-full blur-3xl" data-id="element-19" />
        <div className="absolute bottom-0 left-1/4 w-80 h-80 bg-[#2D6A4F]/5 rounded-full blur-3xl" data-id="element-20" />
      </div>

      <div className="container max-w-6xl mx-auto relative z-10" data-id="element-21">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-22">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-left space-y-6" data-id="element-23">
            <div className="text-center mb-4 space-y-3" data-id="element-24">
              <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#2D6A4F] tracking-tight" data-id="element-25">
                Quincena en verde
              </h2>

              {/* Wistia Video */}
              <div className="max-w-2xl mx-auto" data-id="element-26">
                <div className="rounded-2xl overflow-hidden shadow-2xl" data-id="element-27">
                  <style dangerouslySetInnerHTML={{
                  __html: `
                      wistia-player[media-id='zh6z11cau0']:not(:defined) { 
                        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/zh6z11cau0/swatch'); 
                        display: block; 
                        filter: blur(5px); 
                        padding-top: 56.25%; 
                      }
                    `
                }} data-id="element-28" />
                  <wistia-player media-id="zh6z11cau0" aspect="1.7777777777777777" data-id="element-29"></wistia-player>
                </div>
              </div>

              <div className="flex justify-center" data-id="element-30">
                <AudioPlayer data-id="element-31" />
              </div>
            </div>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#1B4332] leading-tight tracking-tight text-center" data-id="element-32">
              Si cobras por quincena o biweekly…{' '}
              <span className="text-[#2D6A4F] relative inline-block" data-id="element-33">
                esto te va a pegar
                <svg className="absolute w-full h-3 -bottom-1 left-0 text-[#F4A261]" viewBox="0 0 100 10" preserveAspectRatio="none" data-id="element-34">
                  <path d="M0 5 Q 50 10 100 5" stroke="currentColor" strokeWidth="4" fill="none" data-id="element-35" />
                </svg>
              </span>
            </h1>

            <div className="space-y-4 text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-36">
              <p data-id="element-37">Déjame adivinar una escena.</p>
              <p data-id="element-38">
                Vas en mitad de quincena. O vas por la primera semana del pago
                biweekly.
              </p>
              <p data-id="element-39">Abres la app del banco "solo para mirar". Y ahí está.</p>
              <p className="font-medium text-[#2D6A4F]" data-id="element-40">
                Ese mini golpe en el pecho. Ese vacío chiquito que no se
                explica, pero se siente.
              </p>
            </div>

            <div className="pt-4" data-id="element-41">
              <Button size="xl" withIcon onClick={scrollToPricing} className="w-full sm:w-auto shadow-xl shadow-[#F4A261]/20" data-id="element-42">
                Quiero dejar de adivinar
              </Button>
              <p className="mt-3 text-sm text-gray-500 italic" data-id="element-43">
                *Sistema de 7 días. Sin Excel. Sin regaños.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 40,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative flex justify-center lg:justify-end" data-id="element-44">
            <div className="relative w-full max-w-md aspect-[3/4] rounded-2xl" data-id="element-45">
              <div className="absolute inset-0 bg-[#2D6A4F] rounded-2xl rotate-3 opacity-20 transform scale-95 translate-y-4" data-id="element-46" />
              <img src="https://cdn.magicpatterns.com/uploads/9WrQcZWLeYMEo1qTCJ92wY/Producto_Principal.png" alt="Portada del ebook Quincena en Verde - Plan de 7 días para controlar tu dinero" className="relative z-10 w-full h-auto rounded-lg shadow-2xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-47" />

              {/* Floating badges */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 1,
              duration: 0.5
            }} className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-lg border border-gray-100 z-20 max-w-[180px]" data-id="element-48">
                <p className="text-sm font-bold text-[#1B4332]" data-id="element-49">❌ Sin Excel</p>
                <p className="text-xs text-gray-500" data-id="element-50">
                  Olvídate de las hojas de cálculo complicadas
                </p>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 1.2,
              duration: 0.5
            }} className="absolute top-1/2 -translate-y-1/2 -right-6 bg-[#2D6A4F] text-white p-4 rounded-xl shadow-lg z-20 max-w-[160px]" data-id="element-51">
                <p className="text-sm font-bold" data-id="element-52">⏱️ 10 min al día</p>
                <p className="text-xs text-white/80" data-id="element-53">Plan corto y realista</p>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}